import { format, formatDistanceToNowStrict } from "date-fns";

interface TimestampProps {
  value?: string | null;
}

/** Relative age that keeps its exact value in a tooltip. */
export function Timestamp({ value }: TimestampProps) {
  if (!value) {
    return <>—</>;
  }
  const date = new Date(value);
  return (
    <time dateTime={date.toISOString()} title={format(date, "PPpp")}>
      {formatDistanceToNowStrict(date, { addSuffix: true })}
    </time>
  );
}
